/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Hub_GroupInputs */

const en_us2_coaching_hub_group = /** @type {(inputs: Coaching_Hub_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coaching`)
};

const pt_br2_coaching_hub_group = /** @type {(inputs: Coaching_Hub_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal`)
};

const pt_pt2_coaching_hub_group = /** @type {(inputs: Coaching_Hub_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal`)
};

/** @type {(inputs: Coaching_Hub_GroupInputs) => LocalizedString} */
const es_419_coaching_hub_group = en_us2_coaching_hub_group;

/** @type {(inputs: Coaching_Hub_GroupInputs) => LocalizedString} */
const fr_fr2_coaching_hub_group = en_us2_coaching_hub_group;

/** @type {(inputs: Coaching_Hub_GroupInputs) => LocalizedString} */
const de_de2_coaching_hub_group = en_us2_coaching_hub_group;

/** @type {(inputs: Coaching_Hub_GroupInputs) => LocalizedString} */
const it_it2_coaching_hub_group = en_us2_coaching_hub_group;

/**
* | output |
* | --- |
* | "Coaching" |
*
* @param {Coaching_Hub_GroupInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_hub_group = /** @type {((inputs?: Coaching_Hub_GroupInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Hub_GroupInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_hub_group(inputs)
	if (locale === "es-419") return es_419_coaching_hub_group(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_hub_group(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_hub_group(inputs)
	if (locale === "de-DE") return de_de2_coaching_hub_group(inputs)
	if (locale === "it-IT") return it_it2_coaching_hub_group(inputs)
	return en_us2_coaching_hub_group(inputs)
});
export { coaching_hub_group as "coaching.hub_group" }